import React from 'react';
import { TableContainer } from '../common';

export const MESSAGES = {
  title: 'Listado de tratamientos',
  created: 'El tratamiento ha sido creado correctamente',
  edited: 'El tratamiento ha sido editado correctamente',
  deleted: 'El tratamiento ha sido eliminado correctamente',
  deleteConfirmation: treatment =>
    `¿Estas seguro/a de que queres eliminar el tratamiento ${treatment.name}?`,
};

const COLUMNS = [
  {
    id: 'name',
    label: 'Nombre',
    minWidth: 100,
  },
];

export const ENTITY_PROPS = {
  entityName: 'tratamiento',
  endpoint: 'treatments',
  path: '/home/treatments',
};

const TreatmentsTable = () => {
  return <TableContainer entityProps={ENTITY_PROPS} messages={MESSAGES} columns={COLUMNS} />;
};

export default TreatmentsTable;
